module.exports = [
  'en-de',
  'de-de',
  'en-es',
  'es-es',
  'en-fr',
  'fr-fr',
  'en-nl',
  'en-it',
  'en-be',
  'en-se',
  'en-mt',
  'en-ie',
  'en-gr',
  'en-pt',
  'en-hu',
  'en-eu',
];
